"use client";

import { Toaster as ChakraToaster, createToaster, Toast, type CreateToasterReturn } from "@chakra-ui/react";

export const toaster: CreateToasterReturn = createToaster({
  placement: "top",
  pauseOnPageIdle: true,
  gap: 12,
  offsets: { top: "24px", left: "50%", right: "0", bottom: "0" },
});

export function Toaster() {
  return (
    <ChakraToaster toaster={toaster}>
      {(toast) => (
        <Toast.Root
          key={toast.id}
          css={{
            minWidth: "360px",
            maxWidth: "420px",
            padding: "16px 20px",
            backgroundColor: "white",
            border: "0.5px solid var(--color-border)",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(8px)",
            transform: "translateX(-50%)",
          }}
        >
          {toast.title && (
            <Toast.Title
              css={{
                fontSize: "14px",
                fontWeight: "600",
                color: "var(--color-text-primary)",
                marginBottom: toast.description ? "4px" : "0",
              }}
            >
              {toast.title}
            </Toast.Title>
          )}
          {toast.description && (
            <Toast.Description
              css={{
                fontSize: "13px",
                color: "var(--color-text-secondary)",
                lineHeight: "1.5",
              }}
            >
              {toast.description}
            </Toast.Description>
          )}
          <Toast.CloseTrigger
            css={{
              position: "absolute",
              top: "12px",
              right: "12px",
              color: "var(--color-text-muted)",
              cursor: "pointer",
              opacity: 0.6,
              transition: "opacity 150ms",
              "&:hover": {
                opacity: 1,
              },
            }}
          />
        </Toast.Root>
      )}
    </ChakraToaster>
  );
}
